import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const EmbedWrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: no-wrap;

    iframe:nth-child(1) {
        flex-basis: 100%;
        width: auto;
        max-width: 100%;
        height: 100%;
        min-height: 100%;
        height: -webkit-fill-available;
        min-height: -webkit-fill-available;
    }

    iframe:nth-child(2) {
        flex-basis: 300px;
        height: auto;
        width: auto;
        max-width: 100%;
        min-height: 100%;
    }

    @media (max-width: 1000px) {
        flex-direction: column;

        iframe:nth-child(2) {
            flex-basis: 100%;
        }
    }
`;

const RawEmbed = ({ embedUrl, embedCode, dataQa, customIFrameAttributes }) => {
    if (embedUrl && embedUrl.length) {
        return (
            <EmbedWrap data-qa={dataQa}>
                <iframe src={embedUrl} title="video embed" {...customIFrameAttributes} data-qa={`${dataQa}-iframe`} />
            </EmbedWrap>
        );
    }

    return (
        <EmbedWrap
            data-qa={dataQa}
            dangerouslySetInnerHTML={{ __html: embedCode }} // eslint-disable-line react/no-danger
        />
    );
};

export default RawEmbed;

RawEmbed.propTypes = {
    embedUrl: PropTypes.string,
    embedCode: PropTypes.string,
    dataQa: PropTypes.string,
    customIFrameAttributes: PropTypes.shape({
        title: PropTypes.string,
        frameBorder: PropTypes.string,
        allow: PropTypes.string,
        allowFullScreen: PropTypes.bool,
    }),
};

RawEmbed.defaultProps = {
    embedUrl: '',
    embedCode: '',
    dataQa: '',
    customIFrameAttributes: {},
};
